/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../com/atproto/repo/strongRef.defs.js'
import * as LabelDefs from '../../com/atproto/label/defs.defs.js'

const $nsid = 'site.standard.document'

export { $nsid }

type Contributor = {
  $type?: 'site.standard.document#contributor'
  did: l.DidString
  displayName?: string
  role?: string
}

export type { Contributor }

const contributor = /*#__PURE__*/ l.typedObject<Contributor>(
  $nsid,
  'contributor',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    displayName: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 100, maxLength: 1000 }),
    ),
    role: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 100, maxLength: 1000 }),
    ),
  }),
)

export { contributor }

/** A document record representing a published article, blog post, or other content. Documents can belong to a publication or exist independently. */
type Main = {
  $type: 'site.standard.document'

  /**
   * Strong reference to a Bluesky post. Useful to keep track of comments off-platform.
   */
  bskyPostRef?: RepoStrongRef.Main

  /**
   * Open union used to define the record's content. Each entry must specify a $type and may be extended with other lexicons to support additional content formats.
   */
  content?: l.Unknown$TypedObject
  contributors?: Contributor[]

  /**
   * Image to used for thumbnail or cover image. Less than 1MB is size.
   */
  coverImage?: l.BlobRef

  /**
   * A brief description or excerpt from the document.
   */
  description?: string

  /**
   * Self-label values for this post. Effectively content warnings.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject

  /**
   * Array of values describing relationships between this document and external resources
   */
  links?: l.Unknown$TypedObject

  /**
   * Combine with site or publication url to construct a canonical URL to the document. Prepend with a leading slash.
   */
  path?: string

  /**
   * Timestamp of the documents publish time.
   */
  publishedAt: l.DatetimeString

  /**
   * Points to a publication record (at://) or a publication url (https://) for loose documents. Avoid trailing slashes.
   */
  site: l.UriString

  /**
   * Array of strings used to tag or categorize the document. Avoid prepending tags with hashtags.
   */
  tags?: string[]

  /**
   * Plaintext representation of the documents contents. Should not contain markdown or other formatting.
   */
  textContent?: string

  /**
   * Title of the document.
   */
  title: string

  /**
   * Timestamp of the documents last edit.
   */
  updatedAt?: l.DatetimeString
}

export type { Main }

/** A document record representing a published article, blog post, or other content. Documents can belong to a publication or exist independently. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    bskyPostRef: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
    content: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([], false)),
    contributors: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<Contributor>((() => contributor) as any),
      ),
    ),
    coverImage: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({ accept: ['image/*'], maxSize: 1000000 }),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 3000, maxLength: 30000 }),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    links: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([], false)),
    path: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    publishedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    site: /*#__PURE__*/ l.string({ format: 'uri' }),
    tags: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ maxGraphemes: 128, maxLength: 1280 }),
      ),
    ),
    textContent: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    title: /*#__PURE__*/ l.string({ maxGraphemes: 500, maxLength: 5000 }),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { main }

export const $type = $nsid
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
